import React, { FC, useEffect } from "react";

export const VerifyAccount: FC = () => {
    const redirect = () => {
        const queryString = window.location.search;
        window.location.replace(`https://olyns.com/verify-account${queryString}`);
    };
    useEffect(() => {
        redirect();
    }, []);
    return <div/>
};